import { render, staticRenderFns } from "./MetaList.vue?vue&type=template&id=94d2af74&scoped=true&"
import script from "./MetaList.vue?vue&type=script&lang=ts&"
export * from "./MetaList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d2af74",
  null
  
)

export default component.exports